import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { duplicateMemberReportRecords } from './report.action';

@Injectable({ providedIn: 'root' })
export class DuplicateMemberReportTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                id: '',
                member_number: '',
                member_name: '',
                club_name: null,
                postal_code: '',
                member_phone: '',
                dossiers_count: '',
                member_email: '',
                created_at: ''
            }

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'season_name';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    clubs = [];
    categories = [];

    columns = [
                { prop: 'id', name: 'REPORTS.member-id', sortable: false, hasFilter: true, filter: "input", widthSet: 100},
                { prop: 'member_number', name: 'REPORTS.member-number', sortable: false, hasFilter: true, filter: "input", widthSet: 130},
                { prop: 'member_name', name: 'REPORTS.member', sortable: false, hasFilter: true, filter: "input", widthSet: 100},
                { prop: 'club_name', name: 'REPORTS.club', sortable: false, hasFilter: true, filter: "select", options: 'clubs', options_id: "id", options_label: "club_name"},
                { prop: 'dossiers', name: 'REPORTS.dossiers', sortable: false, hasFilter: false, filter: "input", widthSet: 70},
                { prop: 'postal_code', name: 'REPORTS.postcode', sortable: false, hasFilter: true, filter: "input", widthSet: 100},
                { prop: 'member_phone', name: 'REPORTS.phone', sortable: false, hasFilter: true, filter: "input", widthSet: 120},
                { prop: 'member_email', name: 'REPORTS.email', sortable: false, hasFilter: true, filter: "input", widthSet: 130},
                { prop: 'dossiers_workflow', name: 'REPORTS.active-workflow', sortable: false, hasFilter: false, filter: "input", widthSet: 130},
                { prop: 'created_at', name: 'COMMON.created-date', sortable: false, hasFilter: true, filter: "date", widthSet: 155}
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(duplicateMemberReportRecords());
    }

    hasActiveFilters(){
        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetState(){
        this.filters = {
                id: '',
                member_number: '',
                member_name: '',
                club_name: null,
                postal_code: '',
                member_phone: '',
                dossiers_count: '',
                member_email: '',
                created_at: ''
            }
        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;
    }

    resetFilters(){
        this.resetState();
        this.loadRecords();
    }

}